<template>
    <el-popover
      placement="top"
      trigger="hover"
      width="300px"
      popper-class="dbs-tickborne-popover regenere-new-items-popover"
    >
    <div class = "popover-title">What's included:</div>
    <div class = "popover-text">{{ popoverText }}</div>
      <template v-slot:reference>
        <span class="material-icons-outlined info-icon">
          info
        </span>
      </template>
    </el-popover>
</template>
  

  <script>
  export default {
    name: "RegenereNewItemsPopover",
    props:{
        popoverText:{
            type: String,
            default:""
        }
    }
  }
  </script>
  <style scoped>
  .info-icon {
    font-size: 18px;
  }
  .regenere-new-items-popover {
    max-width: 300px;
    padding: 6px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    border-radius: 2px;
  }
  .popover-title {
    color: #FFF;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .popover-text{
    color: #FFF;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  </style>